import { render, staticRenderFns } from "./homepage.vue?vue&type=template&id=ca297042&scoped=true"
import script from "./homepage.vue?vue&type=script&lang=js"
export * from "./homepage.vue?vue&type=script&lang=js"
import style0 from "./homepage.vue?vue&type=style&index=0&id=ca297042&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca297042",
  null
  
)

export default component.exports